/* eslint-disable-next-line  no-unused-vars */
import React, { createElement } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

export default function ModalDialog(props) {
  const {
    openModal,
    setOpenModal,
    dialogTitle,
    dialogContent,
    onSubmit,
    onCancel,
    submitButtonText,
    cancelButtonText,
  } = props;

  const handleDialogOk = () => {
    onSubmit ? onSubmit(openModal) : setOpenModal(false);
  };

  const handleDialogClose = () => {    
    onCancel ? onCancel() : setOpenModal(false);
  };

  const getContent = () => {
    return dialogContent ? dialogContent : <></>;
  };

  const getDialog = () => {
    return (
      <Dialog
        fullWidth
        open={openModal ? true : false}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {dialogTitle ? dialogTitle : "Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          {getContent()}
        </DialogContent>
        <DialogActions sx={{ mb: 2, mr: 2 }}>
          <Button
            variant="contained"
            color="info"
            type="submit"
            onClick={handleDialogOk}
          >
            {submitButtonText ? submitButtonText : "Delete"}
          </Button>

          <Button variant="contained" color="info" onClick={handleDialogClose}>
            {cancelButtonText ? cancelButtonText : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return <>{getDialog()}</>;
}

ModalDialog.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  dialogTitle: PropTypes.string,
  dialogContent: PropTypes.object,
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};
